<form [formGroup]="formGroup">
  <div class="bg-white p-3" style="border-radius: 4px">
    <h4>{{ 'cash-transaction.main-info' | translate }}</h4>
    <div nz-row [nzGutter]="[16, 16]" *ngIf="mode !== itemMode.View">
      <div nz-col [nzSpan]="12">
        <app-control formControlName="deposit_date" [max]="currentDateMax" [controlConfig]="{title: 'top-up.date', type: 'date', required: true}"></app-control>
      </div>
      <div nz-col [nzSpan]="12">
        <app-control formControlName="payment_type_id" [options]="listPaymentType"
          [controlConfig]="{title: 'top-up.payment_type', type: 'dropdown', required: true}"></app-control>
      </div>
      <div nz-col [nzSpan]="12">
        <app-control formControlName="service_card_id" [options]="listServiceCard" (getMoreData)="getMoreDataServiceCard($event)"
          (dropdownSearch)="filterDataServiceCard($event)"
          [controlConfig]="{title: 'card.code', type: 'dropdownServer', required: true}"></app-control>
      </div>
      <div nz-col [nzSpan]="12">
        <app-control formControlName="owner" [controlConfig]="{title: 'service-card.owner', type: 'text'}"></app-control>
      </div>
      <div nz-col [nzSpan]="12">
        <app-control formControlName="apartment_ids" [controlConfig]="{title: 'apartment.code', type: 'text'}"></app-control>
      </div>
      <div nz-col [nzSpan]="12">
        <app-control formControlName="sum" [controlConfig]="{title: 'cash-transaction.cash_amount', type: 'number', required: true}"></app-control>
      </div>
      <div nz-col [nzSpan]="12">
        <app-control formControlName="payment_method" [options]="listPaymentMethod"
          [controlConfig]="{title: 'payment.type', type: 'dropdown', required: true}"></app-control>
      </div>
      <div nz-col [nzSpan]="12">
        <app-control formControlName="payer" [controlConfig]="{title: 'billing.payer', required: true, type: 'text'}"></app-control>
      </div>
      <div nz-col [nzSpan]="12">
        <app-control formControlName="ref_no" [controlConfig]="{title: 'top-up.reference-no', type: 'text'}"></app-control>
      </div>
      <div nz-col [nzSpan]="12">
        <app-control formControlName="voucher_no" [controlConfig]="{title: 'payment.exchange-no', type: 'text', required: true}"></app-control>
      </div>
      <div nz-col [nzSpan]="12">
        <app-control formControlName="voucher_amount"
          [controlConfig]="{title: 'payment.exchange-amount', type: 'number', maxlength: 14, required: true}"></app-control>
      </div>
      <div nz-col [nzSpan]="12">
        <app-control formControlName="expired_date" [min]="currentDateMax" [controlConfig]="{title: 'payment.voucher-expire', type: 'date'}"></app-control>
      </div>
      <div nz-col [nzSpan]="24">
        <app-control formControlName="note" [controlConfig]="{title: 'note', type: 'textarea'}"></app-control>
      </div>
    </div>

    <div nz-row [nzGutter]="[16, 16]" *ngIf="mode === itemMode.View">
      <div nz-col [nzSpan]="6">
        <div>{{ 'cash-transaction.ticket_no' | translate }}</div>
        <div class="content">{{ dataView?.ticket_no || '-' }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'top-up.date' | translate }}</div>
        <div class="content">{{ (dataView?.deposit_date | date: 'dd/MM/yyyy') || '-' }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'card.code' | translate }}</div>
        <div class="content">{{ dataView?.card_no || '-' }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'service-card.owner' | translate }}</div>
        <div class="content">{{ dataView?.owner || '-' }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'cash-transaction.cash' | translate }}</div>
        <div class="content">{{ (dataView?.sum | number) || '-' }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'payment.type' | translate }}</div>
        <ng-container *ngFor="let itemPayment of listPaymentMethodCache">
          <div class="content" *ngIf="itemPayment.value === dataView?.payment_method">{{ itemPayment.text | translate }}</div>
        </ng-container>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'billing.payer' | translate }}</div>
        <div class="content">{{ (dataView?.payer || '-') }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'top-up.reference-no' | translate }}</div>
        <div class="content">{{ (dataView?.ref_no || '-') }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'payment.exchange-no' | translate }}</div>
        <div class="content">{{ (dataView?.voucher_no || '-') }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'payment.exchange-amount' | translate }}</div>
        <div class="content">{{ (dataView?.voucher_amount | number) || '-' }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'payment.date-expire' | translate }}</div>
        <div class="content">{{ (dataView?.expired_date | date: 'dd/MM/yyyy') || '-' }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'note' | translate }}</div>
        <div class="content">{{ dataView?.note || '-' }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'created' | translate }}</div>
        <div class="content">{{ (dataView?.date_created | date: 'dd/MM/yyyy HH:mm:ss') || '-' }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'creator' | translate }}</div>
        <div class="content">{{ dataView?.creator || '-' }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'updated' | translate }}</div>
        <div class="content">{{ (dataView?.date_updated | date: 'dd/MM/yyyy HH:mm:ss') || '-' }}</div>
      </div>
      <div nz-col [nzSpan]="6">
        <div>{{ 'updater' | translate }}</div>
        <div class="content">{{ dataView?.updater || '-' }}</div>
      </div>
    </div>
  </div>
</form>
<div *nzModalTitle class="title-modal">{{ ('cash-transaction.' + mode) |translate }}</div>
<div *nzModalFooter>
  <button nz-button class="btn-cancel-modal" (click)="destroyModal()">{{ 'close' | translate }}</button>
  <ng-container *ngIf="mode == itemMode.View && dataView?.deleted === deleteStatus.NO">
    <button nz-button nzType="primary" (click)="editMode()">{{ 'edit'| translate }}</button>
  </ng-container>
  <ng-container *ngIf="mode !== itemMode.View">
    <button nz-button nzType="primary" (click)="onSave()">{{ 'save' | translate }}</button>
  </ng-container>
</div>